import { Input, Tag, Button } from "antd";
import React, { useState } from "react";
import style from "../solo.module.sass";

const VariableAcl = (props: any) => {
    const {variableAcl, setVariableAcl, teardownActiveTab, setTeardownActiveTab, setupActiveTab, setSetupActiveTab, setShowVariableAcl, name } = props
    return (
        <>  
            <div style={{overflow: "auto", height: "calc(100% - 125px)"}}>
                <div style={{margin: "8px 11px"}}>
                    <div style={{height: "34px", backgroundColor: "rgba(0, 40, 85, 0.12)", borderRadius: "4px", color: "#052f35 ", fontSize: "14px", fontWeight: 700, padding: "8px 0px 8px 8px"}}>
                        Setup
                    </div>
                    <div style={{marginTop: "17px", display: "flex", flexDirection: "row"}}>
                        <div onClick={() => {setSetupActiveTab("freeze")}} style= {{cursor: "pointer"}}>
                            <div style={{color:"#052f35 ", fontSize: "14px", fontWeight: setupActiveTab == "freeze" ? 600 : 400, margin: "0px 19px"}}>Freeze</div>
                            <div style={{ borderBottom: setupActiveTab == "freeze" ? "2px #F1722E solid" : "1px rgb(202, 213, 233) solid", margin: "9px 0px 18px 0px"}}></div>
                        </div>
                        <div onClick={() => {setSetupActiveTab("unfreeze")}} style= {{cursor: "pointer"}}>
                            <div style={{color: "#052f35 ", fontSize: "14px", fontWeight: setupActiveTab == "unfreeze" ? 600 : 400, margin: "0px 19px"}}>Unfreeze</div>
                            <div style={{ borderBottom: setupActiveTab == "unfreeze" ? "2px #F1722E solid" : "1px rgb(202, 213, 233) solid", margin: "9px 0px 18px 0px"}}></div>
                        </div>
                        <div onClick={() => {setSetupActiveTab("hide")}} style= {{cursor: "pointer"}}>
                            <div style={{color: "#052f35 ", fontSize: "14px", fontWeight: setupActiveTab == "hide" ? 600 : 400, margin: "0px 19px"}}>Hide</div>
                            <div style={{ borderBottom: setupActiveTab == "hide" ? "2px #F1722E solid" : "1px rgb(202, 213, 233) solid", margin: "9px 0px 18px 0px"}}></div>
                        </div>
                        <div onClick={() => {setSetupActiveTab("unhide")}} style= {{cursor: "pointer"}}>
                            <div style={{color: "#052f35 ", fontSize: "14px", fontWeight: setupActiveTab == "unhide" ? 600 : 400, margin: "0px 19px"}}>Unhide</div>
                            <div style={{ borderBottom: setupActiveTab == "unhide" ? "2px #F1722E solid" : "1px rgb(202, 213, 233) solid", margin: "9px 0px 18px 0px"}}></div>
                        </div>
                    </div>
                    {setupActiveTab == "freeze" && <div style={{margin: "0px 0px 9px 0px"}}>
                        <SelectTags value={variableAcl?.setup?.freeze} lock={props.lock}
                            onChange={(e: any) => {
                                const freeze = e.length > 0 ? e : undefined
                                setVariableAcl({...variableAcl, ...{ setup: {...variableAcl.setup, freeze} }})}
                            } />
                    </div>}
                    {setupActiveTab == "unfreeze" && <div style={{margin: "0px 0px 9px 0px"}}>
                        <SelectTags value={variableAcl?.setup?.unfreeze} lock={props.lock}
                            onChange={(e: any) => {
                                const unfreeze = e.length > 0 ? e : undefined
                                setVariableAcl({...variableAcl, ...{ setup: {...variableAcl.setup, unfreeze} }})}
                            } />
                    </div>}
                    {setupActiveTab == "hide" && <div style={{margin: "0px 0px 9px 0px"}}>
                        <SelectTags value={variableAcl?.setup?.hide} lock={props.lock}
                            onChange={(e: any) => {
                                const hide = e.length > 0 ? e : undefined
                                setVariableAcl({...variableAcl, ...{ setup: {...variableAcl.setup, hide} }})}
                            } />
                    </div>}
                    {setupActiveTab == "unhide" && <div style={{margin: "0px 0px 9px 0px"}}>
                        <SelectTags value={variableAcl?.setup?.unhide} lock={props.lock}
                            onChange={(e: any) => {
                                const unhide = e.length > 0 ? e : undefined
                                setVariableAcl({...variableAcl, ...{ setup: {...variableAcl.setup, unhide} }})}
                            } />
                    </div>}
                </div>
                <div style={{ borderBottom: "1px rgb(202, 213, 233) solid", margin: "20px 11px"}}></div>
                <div style={{margin: "8px 11px"}}>
                    <div style={{height: "34px", backgroundColor: "rgba(0, 40, 85, 0.12)", borderRadius: "4px", color: "#052f35 ", fontSize: "14px", fontWeight: 700, padding: "8px 0px 8px 8px"}}>
                        Teardown
                    </div>
                    <div style={{marginTop: "17px", display: "flex", flexDirection: "row"}}>
                        <div onClick={() => {setTeardownActiveTab("freeze")}} style= {{cursor: "pointer"}}>
                            <div style={{color:"#052f35 ", fontSize: "14px", fontWeight: teardownActiveTab == "freeze" ? 600 : 400, margin: "0px 19px"}}>Freeze</div>
                            <div style={{ borderBottom: teardownActiveTab == "freeze" ? "2px #F1722E solid" : "1px rgb(202, 213, 233) solid", margin: "9px 0px 18px 0px"}}></div>
                        </div>
                        <div onClick={() => {setTeardownActiveTab("unfreeze")}} style= {{cursor: "pointer"}}>
                            <div style={{color: "#052f35 ", fontSize: "14px", fontWeight: teardownActiveTab == "unfreeze" ? 600 : 400, margin: "0px 19px"}}>Unfreeze</div>
                            <div style={{ borderBottom: teardownActiveTab == "unfreeze" ? "2px #F1722E solid" : "1px rgb(202, 213, 233) solid", margin: "9px 0px 18px 0px"}}></div>
                        </div>
                        <div onClick={() => {setTeardownActiveTab("hide")}} style= {{cursor: "pointer"}}>
                            <div style={{color: "#052f35 ", fontSize: "14px", fontWeight: teardownActiveTab == "hide" ? 600 : 400, margin: "0px 19px"}}>Hide</div>
                            <div style={{ borderBottom: teardownActiveTab == "hide" ? "2px #F1722E solid" : "1px rgb(202, 213, 233) solid", margin: "9px 0px 18px 0px"}}></div>
                        </div>
                        <div onClick={() => {setTeardownActiveTab("unhide")}} style= {{cursor: "pointer"}}>
                            <div style={{color: "#052f35 ", fontSize: "14px", fontWeight: teardownActiveTab == "unhide" ? 600 : 400, margin: "0px 19px"}}>Unhide</div>
                            <div style={{ borderBottom: teardownActiveTab == "unhide" ? "2px #F1722E solid" : "1px rgb(202, 213, 233) solid", margin: "9px 0px 18px 0px"}}></div>
                        </div>
                    </div>
                    {teardownActiveTab == "freeze" && <div style={{margin: "0px 0px 9px 0px"}}>
                        <SelectTags value={variableAcl?.teardown?.freeze} lock={props.lock}
                            onChange={(e: any) => {
                                const freeze = e.length > 0 ? e : undefined
                                setVariableAcl({...variableAcl, ...{ teardown: {...variableAcl.teardown, freeze} }})}
                            } />
                    </div>}
                    {teardownActiveTab == "unfreeze" && <div style={{margin: "0px 0px 9px 0px"}}>
                        <SelectTags value={variableAcl?.teardown?.unfreeze} lock={props.lock}
                            onChange={(e: any) => {
                                const unfreeze = e.length > 0 ? e : undefined
                                setVariableAcl({...variableAcl, ...{ teardown: {...variableAcl.teardown, unfreeze} }})}
                            } />
                    </div>}
                    {teardownActiveTab == "hide" && <div style={{margin: "0px 0px 9px 0px"}}>
                        <SelectTags value={variableAcl?.teardown?.hide} lock={props.lock}
                            onChange={(e: any) => {
                                const hide = e.length > 0 ? e : undefined
                                setVariableAcl({...variableAcl, ...{ teardown: {...variableAcl.teardown, hide} }})}
                            } />
                    </div>}
                    {teardownActiveTab == "unhide" && <div style={{margin: "0px 0px 9px 0px"}}>
                        <SelectTags value={variableAcl?.teardown?.unhide} lock={props.lock}
                            onChange={(e: any) => {
                                const unhide = e.length > 0 ? e : undefined
                                setVariableAcl({...variableAcl, ...{ teardown: {...variableAcl.teardown, unhide} }})}
                            } />
                    </div>}
                </div>
            </div>
            {<div className={style.footer} style={{padding: "0px 15px 5px 15px"}}>
                {!props.lock && <Button
                    disabled={!name}
                    style={{ backgroundColor: "#F1722E", color: "#FFFFFF", width: "100%", height: 50 }}
                    onClick={() => { setShowVariableAcl(false); setTeardownActiveTab("freeze"); setSetupActiveTab("freeze") }} >UPDATE</Button>}
            </div>}
        </>
    )
}

const SelectTags = (props: any) => {
    const [inputValue, setInputValue] = useState("")
    const handleClose = (removedTag: any) => {
        const newTags = props.value.filter((tag: any) => tag !== removedTag);
        props.onChange(newTags)
    };
    const handleInputConfirm = () => {
        props.onChange([...props.value || [], inputValue])
        setInputValue("")
    };

    return <>
        <Input
            disabled={props.lock}
            style={{ width: "100%", height: "36px", color: "#000610", fontSize: 14, border: props.nameCheck ? "1px solid #FF0000" : "1px solid #909BAD", marginBottom: "2px" }}
            value={inputValue}
            placeholder="Enter the variable"
            onChange={(e: any) => setInputValue(e.target.value)}
            onPressEnter={handleInputConfirm}
        />
        {props.value?.map((value: any) => {
            return <Tag
                key={value}
                closable={!props.lock}
                style={{color: "black", padding: "4px 7px 5.5px 6px", fontSize: "14px", fontWeight: 400, backgroundColor: "#F3F3F3", marginTop: "7px"}}
                onClose={() => handleClose(value)}
                >
                {value}
            </Tag>
        })}
        
    </>
};

export default VariableAcl;